import React from 'react'
import HighlightsSlice from 'src/slices/brandEducation/highlightsSlice'
import HowItWorksSlice from 'src/slices/brandEducation/howItWorksSlice'
import ProfileHighlightSlice from 'src/slices/brandEducation/profileHighlightSlice'
import StoryCarouselSlice from 'src/slices/brandEducation/storyCarouselSlice'
import TimelineSlice from 'src/slices/brandEducation/timelineSlice'
import CrewCalloutSlice from 'src/slices/crewConversion/crewCalloutSlice'
import CrewRisingSlice from 'src/slices/crewConversion/crewRisingSlice'
import BannerCtaSlice from 'src/slices/ctas/bannerCtaSlice'
import CallToActionSlice from 'src/slices/ctas/callToActionSlice'
import CardsCtaSlice from 'src/slices/ctas/cardsCtaSlice'
import CateringOptionsSlice from 'src/slices/ctas/cateringOptionsSlice'
import CollageStatsCalloutSlice from 'src/slices/ctas/collageStatsCalloutSlice'
import CommunityInvolvementSlice from 'src/slices/ctas/communityInvolvementSlice'
import ConfigurableCtaSlice from 'src/slices/ctas/configurableCtaSlice'
import CountdownBannerSlice from 'src/slices/ctas/countdownBannerSlice'
import DoubleCtaSlice from 'src/slices/ctas/doubleCtaSlice'
import DynamicCtaSlice from 'src/slices/ctas/dynamicCtaSlice'
import FaqCtaSlice from 'src/slices/ctas/faqCtaSlice'
import HostFundraiserSlice from 'src/slices/ctas/hostFundraiserSlice'
import ImageGallerySlice from 'src/slices/ctas/imageGallerySlice'
import ImageReelSlice from 'src/slices/ctas/imageReelSlice'
import LogoCTASlice from 'src/slices/ctas/logoCtaSlice'
import RecruitingCtaSlice from 'src/slices/ctas/recruitingCtaSlice'
import RichTextCtaSlice from 'src/slices/ctas/richTextCtaSlice'
import ArticlesLibrarySlice from 'src/slices/engagement/articlesLibrarySlice'
import ChickenFingerCalculatorSlice from 'src/slices/engagement/chickenFingerCalculatorSlice'
import GlitterEffectSlice from 'src/slices/engagement/glitterEffectSlice'
import NewsroomArticlesLibrarySlice from 'src/slices/engagement/newsroomArticlesLibrarySlice'
import RecentArticlesSlice from 'src/slices/engagement/recentArticlesSlice'
import SaucyCarouselSlice from 'src/slices/engagement/saucyCarouselSlice'
import CommunitySuccessStoriesSlice from 'src/slices/general/communitySuccessStoriesSlice'
import ContactColumnsSlice from 'src/slices/general/contactColumnsSlice'
import DownloadAssetsSlice from 'src/slices/general/downloadAssetsSlice'
import ECardWidgetSlice from 'src/slices/general/eCardWidgetSlice'
import EmbeddedContentGridSlice from 'src/slices/general/embeddedContentGridSlice'
import EmbeddedContentSlice from 'src/slices/general/embeddedContentSlice'
import FaqCategorySlice from 'src/slices/general/faqCategorySlice'
import FaqSlice from 'src/slices/general/faqSlice'
import HeadlineSlice from 'src/slices/general/headlineSlice'
import IconCardGridSlice from 'src/slices/general/iconCardGridSlice'
import QuoteBlockSlice from 'src/slices/general/quoteBlock'
import QuoteSlice from 'src/slices/general/quoteSlice'
import SearchableFaqSlice from 'src/slices/general/searchableFaqSlice'
import SecondaryNavigationSlice from 'src/slices/general/secondaryNavigationSlice'
import TableSlice from 'src/slices/general/tableSlice'
import TitleAndDescriptionSlice from 'src/slices/general/titleAndDescriptionSlice'
import ArticlesHeroSlice from 'src/slices/heros/articlesHeroSlice'
import BasicHeroSlice from 'src/slices/heros/basicHeroSlice'
import HeroSliderSlice from 'src/slices/heros/heroSliderSlice'
import MinimalHeroSlice from 'src/slices/heros/minimalHeroSlice'
import ArtOfAPerfectMealSlice from 'src/slices/productRouting/artOfAPerfectMealSlice'
import ArtOfAPerfectMealV2Slice from 'src/slices/productRouting/artOfAPerfectMealV2Slice'
import BasicSliderSlice from 'src/slices/productRouting/basicSliderSlice'
import MenuCarouselSlice from 'src/slices/productRouting/menuCarouselSlice'
import MenuItemGroupSlice from 'src/slices/productRouting/menuItemGroupSlice'
import LocatorSlice from 'src/slices/restaurantLocator/locatorSlice'
import UpcomingRestaurantsSlice from 'src/slices/restaurantLocator/upcomingRestaurantsSlice'
import WorldCupLocatorSlice from 'src/slices/restaurantLocator/worldCupLocatorSlice'
import DescriptiveSliderSlice from 'src/slices/slidersAndGrids/descriptiveSliderSlice'
import HoverCardGridSlice from 'src/slices/slidersAndGrids/hoverCardGridSlice'
import ImageGridSlice from 'src/slices/slidersAndGrids/imageGridSlice'
import ImageStripSlice from 'src/slices/slidersAndGrids/imageStripSlice'
import LinkGridSlice from 'src/slices/slidersAndGrids/linkGridSlice'
import MultiMediaGridSlice from 'src/slices/slidersAndGrids/multiMediaGridSlice'
import MultiMediaImageGridSlice from 'src/slices/slidersAndGrids/multiMediaImageGridSlice'
import StaggeredImageCardsSlice from 'src/slices/slidersAndGrids/staggeredImageCardsSlice'
import StatGridSlice from 'src/slices/slidersAndGrids/statGridSlice'
import { PrismicSliceType } from 'src/typings/generated/graphql'

interface Props {
  sliceZone: PrismicSliceType[]
}

const SliceZone = ({ sliceZone }: Props) => {
  const sliceComponents: any = {
    art_of_a_perfect_meal: ArtOfAPerfectMealSlice,
    art_of_a_perfect_meal_v2: ArtOfAPerfectMealV2Slice,
    articles_hero: ArticlesHeroSlice,
    articles_library: ArticlesLibrarySlice,
    banner_cta: BannerCtaSlice,
    basic_hero: BasicHeroSlice,
    basic_slider: BasicSliderSlice,
    call_to_action: CallToActionSlice,
    cards_cta: CardsCtaSlice,
    catering_options: CateringOptionsSlice,
    chicken_finger_calculator: ChickenFingerCalculatorSlice,
    collage_stats_callout: CollageStatsCalloutSlice,
    community_involvement: CommunityInvolvementSlice,
    community_success_stories: CommunitySuccessStoriesSlice,
    configurable_cta: ConfigurableCtaSlice,
    contact_columns: ContactColumnsSlice,
    countdown_banner: CountdownBannerSlice,
    crew_callout: CrewCalloutSlice,
    crew_rising: CrewRisingSlice,
    descriptive_slider: DescriptiveSliderSlice,
    double_cta: DoubleCtaSlice,
    download_assets: DownloadAssetsSlice,
    dynamic_cta: DynamicCtaSlice,
    ecardwidget: ECardWidgetSlice,
    embedded_content: EmbeddedContentSlice,
    embedded_content_grid: EmbeddedContentGridSlice,
    faq: FaqSlice,
    faq_category: FaqCategorySlice,
    faq_cta: FaqCtaSlice,
    glitter_effect: GlitterEffectSlice,
    headline: HeadlineSlice,
    hero_slider: HeroSliderSlice,
    how_it_works: HowItWorksSlice,
    highlights: HighlightsSlice,
    host_a_fundraiser: HostFundraiserSlice,
    hover_card_grid: HoverCardGridSlice,
    icon_card_grid: IconCardGridSlice,
    image_gallery: ImageGallerySlice,
    image_grid: ImageGridSlice,
    image_reel: ImageReelSlice,
    image_strip: ImageStripSlice,
    link_grid: LinkGridSlice,
    locator: LocatorSlice,
    logo_cta: LogoCTASlice,
    menu_carousel: MenuCarouselSlice,
    menu_item_group: MenuItemGroupSlice,
    minimal_hero: MinimalHeroSlice,
    multi_media_grid: MultiMediaGridSlice,
    multi_media_image_grid: MultiMediaImageGridSlice,
    newsroom_articles_library: NewsroomArticlesLibrarySlice,
    profile_highlight: ProfileHighlightSlice,
    quote: QuoteSlice,
    quote_block: QuoteBlockSlice,
    recent_articles: RecentArticlesSlice,
    recruiting_cta: RecruitingCtaSlice,
    rich_text_cta: RichTextCtaSlice,
    saucy_carousel: SaucyCarouselSlice,
    searchable_faq: SearchableFaqSlice,
    secondary_navigation: SecondaryNavigationSlice,
    staggered_image_cards: StaggeredImageCardsSlice,
    stat_grid: StatGridSlice,
    story_carousel: StoryCarouselSlice,
    table: TableSlice,
    timeline: TimelineSlice,
    title_and_description: TitleAndDescriptionSlice,
    upcoming_restaurants: UpcomingRestaurantsSlice,
    world_cup_locator: WorldCupLocatorSlice,
  }

  const sliceZoneContent = sliceZone.map(
    (slice: PrismicSliceType, index: number) => {
      const SliceComponent = sliceComponents[slice.slice_type]
      const key = `slice-${slice.id ?? index}`
      if (SliceComponent) {
        return <SliceComponent slice={slice} key={key} />
      }
      return null
    }
  )

  return (
    <div data-testid="slice-zone" className="container">
      {sliceZoneContent}
    </div>
  )
}

export default SliceZone
